import { createLogic } from 'redux-logic'
// import { map, tap } from 'rxjs/operators'
import * as constants from '../constants'
import { map } from 'rxjs/operators'
const resource = 'compslab'

export const getUserLogic = createLogic({
  type: constants.GET_USER.ACTION,
  processOptions: {
    successType: constants.GET_USER.FULFILLED,
    failType: constants.GET_USER.REJECTED
  },
  process({ keycloak, http }) {
    const { tokenParsed = {} } = keycloak

    return http.get(`/compsad/user/${tokenParsed.preferred_username}`).pipe(
      map(http.getBody),
      map(({ thumbnailPhoto, physicalDeliveryOfficeName }) => {
        const {
          given_name,
          family_name,
          email,
          preferred_username,
          sub
        } = tokenParsed
        const keycloakRole =
          tokenParsed?.resource_access?.[resource]?.roles[0] || ''
        /* eslint no-underscore-dangle: ["error", { "allow": ["_mtm", "_paq"] }]*/
        window._mtm.push({
          event: 'loggedInUser',
          userName: `${given_name} ${family_name}`,
          userEmail: email,
          userGuid: sub,
          officeName: physicalDeliveryOfficeName,
          keycloakRole
        })

        window._paq.push(['setUserId', sub])
        window._paq.push(['setCustomDimension', 1, keycloakRole])
        window._paq.push(['setCustomDimension', 2, physicalDeliveryOfficeName])
        window._paq.push(['setCustomDimension', 4, email])
        window._paq.push(['trackPageView'])

        return {
          ...tokenParsed,
          firstName: given_name,
          lastName: family_name,
          loginName: preferred_username,
          entityUserGuid: sub,
          username: preferred_username,
          thumbnailPhoto
        }
      })
    )
  }
})
